var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qrImage)?_c('section',[_c('img',{staticClass:"img-fluid img-thumbnail",attrs:{"src":_vm.qrImage}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }